import BaseModel from '@launchpad/logic/model/BaseModel';

export default class StipLogModel extends BaseModel {
  /**
   * Get Method
   */
  getMethod(): string {
    return 'GET';
  }

  /**
   * Get list url
   */
  getListUrl(): any {
    return 'admin/temenos/stip-log/logs';
  }

  /**
   * Get details url
   */
  getDetailsUrl(id: string): string | null {
    return `admin/temenos/stip-log/logs/${id}`;
  }

  /**
   * Get default table columns
   */
  getTableColumns(): any {
    return [
      {
        name: 'id',
        label: 'Id',
        sortable: false,
        type: 'field',
      },
      {
        name: 'createdAt',
        label: 'Created',
        sortable: false,
        type: 'field',
      },
      {
        name: 'transactionReference',
        label: 'Transaction Reference',
        sortable: false,
        type: 'field',
      },
      {
        name: 'amount',
        label: 'Amount',
        sortable: false,
        type: 'field',
      },
      {
        name: 'status',
        label: 'Status',
        sortable: false,
        type: 'field',
      },
      {
        name: 'approved',
        label: 'Approved',
        sortable: false,
        type: 'field',
      },
      {
        name: 'approvedByTemenos',
        label: 'Approved by Temenos',
        sortable: false,
        type: 'field',
      },
      {
        name: 'approvedByPannovate',
        label: 'Approved by Pannovate',
        sortable: false,
        type: 'field',
      },
      {
        name: null,
        label: 'Actions',
        sortable: false,
        type: 'actions',
      },
    ];
  }
}
